export default __webpack_public_path__ + "static/media/quinsa.19129917.png";